import http from "@http"
// 日志 	操作类型（0-登录，操作）

//列表  分页
export function getSyslogList(data) {
    return http({
        url: '/lskj-admin/api/admin/sysLog/list',
        method: "post",
        data
    })
}